import type { NextRouter } from 'next/router';
import type { ReactElement } from 'react';
import type { IntlShape } from 'react-intl';

import { Typography } from '@/components/Typography';
import type { paths } from '@/lib/paths';
import * as PM from '@/messages/payment';

import type { OrderDetailsGuestSession } from '../helpers';

import * as S from '../OrderDetailsView.styles';

export type ReturnHistoryOriginalOrderLinkProps = Readonly<{
  formatMessage: IntlShape['formatMessage'];
  guestSession: OrderDetailsGuestSession | undefined;
  orderId: string;
  paths: typeof paths;
  push: NextRouter['push'];
  type: string | undefined;
}>;

export function ReturnHistoryOriginalOrderLink({
  formatMessage,
  guestSession,
  orderId,
  paths,
  push,
  type,
}: ReturnHistoryOriginalOrderLinkProps): ReactElement | null {
  if (type !== 'RETURNHISTORY') return null;

  if (guestSession) {
    if (!guestSession.onViewOriginalOrder) return null;
    return (
      <S.Link onClick={() => guestSession.onViewOriginalOrder?.()}>
        <Typography className='text'>
          {formatMessage(PM.paymentMessages.viewOriginalOrderDetails)}
        </Typography>
      </S.Link>
    );
  }

  return (
    <S.Link
      onClick={() =>
        push(
          paths.myAccount.myOrders.orderDetails.url({
            orderId,
            query: { type: 'ORDERHISTORY' },
          }),
        )
      }
    >
      <Typography className='text'>
        {formatMessage(PM.paymentMessages.viewOriginalOrderDetails)}
      </Typography>
    </S.Link>
  );
}
